import * as React from 'react';
import { HostParts, useHostParts } from '@mam/main/Router/useHostParts';

export const Context = React.createContext<HostParts>({
	host: '',
	hostname: '',
	protocol: 'https',
	subdomain: null,
});

export const ContextProvider: React.FunctionComponent<{ children(value: HostParts): React.ReactNode }> = ({
	children,
}) => {
	const hostParts = useHostParts();
	return <Context.Provider value={hostParts}>{children(hostParts)}</Context.Provider>;
};
